package music.jammers.client.shared.admin.di

import music.jammers.client.shared.admin.presentation.viewmodel.AdminViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val adminModule = module {

    factory {
        AdminViewModel(
            router = get()
        )
    }
}

object AdminComponent : KoinComponent {

    val adminViewModel: AdminViewModel
        get() = getKoin().get<AdminViewModel>()
}